import { useWindowDimensions } from 'react-native';

const BREAKPOINT_MOBILE = 768;

/**
 * A custom hook to determine if the screen is mobile or desktop,
 * consistent with existing responsive logic in the app.
 * @returns {{isMobile: boolean, isDesktop: boolean, screenWidth: number}}
 */
export const useResponsive = () => {
  const { width } = useWindowDimensions();

  const isMobile = width < BREAKPOINT_MOBILE;
  const isDesktop = width >= BREAKPOINT_MOBILE;

  return { isMobile, isDesktop, screenWidth: width };
};
